import dayjs from 'dayjs';

export const parseExcludedFilters = (values) => {
    if (!values || Object.keys(values).length === 0) {
        return {};
    }

    return {
        ...values,
        startDate: values?.startDate ? dayjs(values?.startDate).format('YYYY-MM-DD') : null,
        endDate: values?.endDate ? dayjs(values?.endDate).format('YYYY-MM-DD') : null,
        status: values?.status?.value,
        type: values?.type?.value,
        bankAccount: values?.bankAccount,
        excludedBy: values?.excludedBy?.value,
    };
};

export const parseForReviewFilters = (values) => {
    if (!values || Object.keys(values).length === 0) {
        return {};
    }

    return {
        ...values,
        description: values?.description,
        startDate: values?.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : null,
        endDate: values?.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : null,
        amount: values?.amount,
        amountBuffer: values?.amountBuffer,
        dateBuffer: values?.dateBuffer,
        matches: values?.hasMatches?.value,
        bankAccount: values?.bankAccount,
        type: values?.type?.value,
    };
};

export const parseMatchedFilters = (values) => {
    if (!values || Object.keys(values).length === 0) {
        return {};
    }

    return {
        ...values,
        startDate: values.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : null,
        endDate: values.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : null,
        status: values.status?.value,
        type: values.type?.value,
        bankAccount: values.bankAccount,
        matchedBy: values.matchedBy?.value,
    };
};
